import React from 'react'
import { Controller } from 'react-hook-form'

const RHFTextarea = (props) => {
  const { name, id, isControlled, control, errorObj } = props;
  let isError = false;
  let errorMessage = '';

  if(errorObj && Object?.keys(errorObj)?.includes(name)){
    console.log(errorObj);
    isError=true
    errorMessage = errorObj[name]?.message
  }

  if (isControlled) {
    return (
      <div>
        <Controller
          name={name}
          control={control}
          render={({
            field
          }) => {
            return (
              <>
                <textarea
                  {
                  ...props
                  }
                  {
                    ...field
                  }
                />
                {
                  isError ? <p className='text-[10px] pt-[2px] text-[red]' >{errorMessage}</p> : ""
                }
              </>
            )
          }}
        />

      </div>
    )
  }

  return (
    <div>
      <textarea
        {
        ...props
        }
      />
    </div>
  )
}

export default RHFTextarea